import { ReactNode } from "react";

interface SectionCardProps {
  title: string;
  icon: ReactNode;
  children: ReactNode;
  titleSuffix?: ReactNode;
  headerAction?: ReactNode;
  footer?: ReactNode;
}

const SectionCard = ({
  title,
  icon,
  children,
  titleSuffix,
  headerAction,
  footer,
}: SectionCardProps) => {
  return (
    <div className="section-card">
      <div className="section-card-header">
        <div>
          <h2 className="section-card-title">
            {icon}
            {title}
            {titleSuffix}
          </h2>
        </div>
        {headerAction}
      </div>
      <div className="section-card-content">{children}</div>
      {footer}
    </div>
  );
};

export default SectionCard;
